import { extendTheme, defineStyle, defineStyleConfig } from "@chakra-ui/react";

const activeLabelStyles = {
  transform: "scale(0.85) translateY(-24px)",
};

const thick = defineStyle({
  borderWidth: "80px", // change the width of the border
  borderStyle: "solid", // change the style of the border
  borderRadius: 10, // set border radius to 10
});

const dividerTheme = defineStyleConfig({
  variants: { thick },
});

const theme = extendTheme({
  components: {
    Text: {
      // Default style for light mode
      baseStyle: {
        color: "gray.800", // Change this to your desired light mode color
      },
      // Style for dark mode
      variants: {
        dark: {
          color: "gray.100", // Change this to your desired dark mode color
        },
      },
    },
    Heading: {
      // Default style for light mode
      baseStyle: {
        color: "gray.800", // Change this to your desired light mode color
      },
      // Style for dark mode
      variants: {
        dark: {
          color: "gray.100", // Change this to your desired dark mode color
        },
      },
    },
    a: {
      // Default style for light mode
      baseStyle: {
        color: "gray.800", // Change this to your desired light mode color
      },
      // Style for dark mode
      variants: {
        dark: {
          color: "gray.100", // Change this to your desired dark mode color
        },
      },
    },
    global: {
      body: {
        bg: "#E7EBEE",
        color: "gray.800",
      },
    },
    Divider: dividerTheme,
    Tag: {
      variants: {
        colorScheme: "blue",
        padding: "8px",
        borderRadius: "10px 0px 0px 10px",
        display: "inline-flex",
        alignItems: "center",
      },
    },
    Input: {
      variants: {
        border: "1px solid",
        borderColor: "gray.200",
        borderRadius: "0px 10px 10px 0px",
        padding: "0.5rem 1rem",
        paddingLeft: "10px",
        flex: "1",
      },
    },
    Form: {
      variants: {
        floating: {
          container: {
            _focusWithin: {
              label: {
                ...activeLabelStyles,
              },
            },
            "input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label":
              {
                ...activeLabelStyles,
              },
            label: {
              top: 0,
              left: 0,
              zIndex: 2,
              position: "absolute",
              backgroundColor: "white",
              pointerEvents: "none",
              mx: 3,
              px: 1,
              my: 2,
              transformOrigin: "left top",
            },
          },
        },
      },
    },
  },
});

export default theme;
